import { render } from "./MemberCoachesView.vue?vue&type=template&id=5b321074&scoped=true"
import script from "./MemberCoachesView.vue?vue&type=script&lang=js"
export * from "./MemberCoachesView.vue?vue&type=script&lang=js"

import "./MemberCoachesView.vue?vue&type=style&index=0&id=5b321074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b321074"]])

export default __exports__